import { NICmsContentComponent } from '@icms/core/content';

export namespace NPageFooter {
    export const BLOCK_ID = 'page-footer';

    export interface IBlockDataContent extends NICmsContentComponent.IData {
        components: NICmsContentComponent.IData[];
        links: { text: string; link?: string }[];
        columns: IPageFooterColumn[];
        columnsMobile: IPageFooterColumnMobile[];
        newsletterHeader: string;
        newsletterHeaderImage?: string;
        newsletterCopy?: string;
        newsletterHeaderColor?: string;
        newsletterCopyColor?: string;
        newsletterBackgroundColor?: string;
        newsletterTermsCopy: string;
        reviewsImage?: string;
        reviewsLink?: string;
        socialIcons?: IPageFooterSocialIcon[];
        backgroundColor?: string;
    }

    export interface IPageFooterColumn {
        type: string;
        header?: string;
        image?: string;
        links: {
            text: string;
            link?: string;
            tabLinks: {
                text: string;
                link?: string;
            }[];
        }[];
    }

    export interface IPageFooterColumnMobile {
        type: string;
        width: string;
        header: string;
        link?: string;
        icon: string;
        accordionBackgroundColor?: string;
        links: {
            text: string;
            link?: string;
        }[];
    }

    export interface IPageFooterSocialIcon {
        service?: string;
        link?: string;
    }
}
